export default {"src":"/_next/static/media/DeleteChipIcon.a00d5c86.svg","height":7,"width":8,"blurWidth":0,"blurHeight":0};